export default function ProductIntroduction({ data }) {
  const getText = () => {
    const productIntro = data?.productIntroVO?.productIntro;
    if (productIntro.includes('<img')) {
      const str = productIntro.replace(/<img/g, '<img width="100%" height="100%"');
      return str;
    }
    return productIntro;
  };

  return (
    data?.productIntroVO?.productIntro && (
      <section className="text-[14px] text-[#0b1832] mt-[16px] m-auto pl-[15px] pr-[13px] pt-[10px] pb-[5px] rounded-[8px] border border-solid border-[#ececec]">
        <h2>商品介绍</h2>
        <div className="mt-[14px]" dangerouslySetInnerHTML={{ __html: getText() }}></div>
      </section>
    )
  );
}
